import { useQuery } from "@tanstack/react-query";
import { getProcessingShipmentDetail } from "../../../services/supplierOrderService";
import { shipmentKeys } from "../queryKeys";

export const useShipmentDetail = (shipmentCode) => {

  return useQuery({

    queryKey: shipmentKeys.detail(shipmentCode),

    queryFn: () => getProcessingShipmentDetail(shipmentCode),

    enabled: !!shipmentCode,

  });

};
